<template>
  <div>
    <CSidebarNavTitle v-if="hasAnyPerms([
      'admin.users.search',
    ])">{{ $gettext('Customer Success') }}</CSidebarNavTitle>
    
    <CSidebarNavItem
      v-if="hasAnyPerms(['admin.users.search'])"
      :name="$gettext('Search User')"
      :to="{name: 'customer_success.search'}"
      icon="cip-user"
    />
  </div>
</template>

<script>
export default {
  name: 'CustomerSuccess'
}
</script>